import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      initial={{ y: "115%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: EASE }}
      className="block"
    >
      {children}
    </motion.span>
  </span>
);

export const Chapter = ({ number, title, center = false }) => (
  <Reveal className={`flex items-center gap-4 mb-10 ${center ? "justify-center" : ""}`}>
    <span className="font-cinzel text-[#C5A059] text-sm tracking-[0.35em]">{number}</span>
    <span className="h-px w-14 bg-[#C5A059]/40" />
    <span className="text-xs uppercase tracking-[0.3em] text-[#C5BCAD]">{title}</span>
  </Reveal>
);

export const SectionTitle = ({ children, className = "" }) => (
  <Reveal delay={0.08}>
    <h2
      className={`font-display text-3xl sm:text-4xl lg:text-5xl font-medium tracking-tight text-[#F7F4EE] leading-[1.1] ${className}`}
    >
      {children}
    </h2>
  </Reveal>
);
